import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    InputLabel,
    MenuItem,
    Select,
    FormControl,
    Typography
} from '@mui/material';
import { toast } from 'react-toastify';
import FormGroup from '@mui/material/FormGroup';
import { sendDataToApi } from '../../../API/apiHelper';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IOSSwitch } from '../../../components/UI/CustomizedSwitches';

function CreateAdtCompanyDialog({ open, handleClose, onSuccess, dsp }) {
    const [enableWhiteListRemoval, setEnableWhiteListRemoval] = useState(false);

    const [formData, setFormData] = useState({
        company_name: '',
        adt_domain_name: '',
        irtb_id_dsp: '',
        sh_id: '',
        wl_id_web: '',
        wl_id_inapp: '',
        wl_id_ctv: '',
        threshold: '',
        remove_all: false
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'remove_all' ? value === 'true' : value
        }));
    };

    const handleSubmit = () => {
        const userId = localStorage.getItem('user_id');
        const payload = {
            ...formData,
            ChangedBy: userId,
        };

        sendDataToApi('post', '/api/adtimizer/company/create', payload, false, (data) => {
            if (data.data.success) {
                toast.success('The company has been created!');
                onSuccess();
                setFormData({
                    company_name: '',
                    adt_domain_name: '',
                    irtb_id_dsp: '',
                    sh_id: '',
                    wl_id_web: '',
                    wl_id_inapp: '',
                    wl_id_ctv: '',
                    threshold: '',
                    remove_all: false
                });
                handleClose();
            } else {
                toast.error('The company has not been created!');
                toast.error(data.data.error);
            }
        });
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Create a new company</DialogTitle>
            <DialogContent sx={{ minWidth: '450px' }}>
                <TextField fullWidth margin="dense" name="company_name" label="Company Name" value={formData.company_name} onChange={handleChange} />
                <TextField fullWidth margin="dense" name="adt_domain_name" label="Adtimizer Domain" value={formData.adt_domain_name} onChange={handleChange} />

                <FormControl fullWidth margin="dense">
                    <InputLabel id="dsp-label">iRTB DSP ID</InputLabel>
                    <Select
                        labelId="dsp-label"
                        id="irtb_id_dsp"
                        name="irtb_id_dsp"
                        value={formData.irtb_id_dsp}
                        onChange={handleChange}
                        required
                        label="iRTB DSP ID"
                    >
                        {dsp.map((item) => (
                            <MenuItem key={item.value.id} value={item.value.id}>
                                {item.value.name} (ID: {item.value.id})
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField fullWidth margin="dense" name="sh_id" label="SmartHub ID" type="number" value={formData.sh_id} onChange={handleChange} />
                <TextField fullWidth margin="dense" name="wl_id_web" label="WEB White List" type="number" value={formData.wl_id_web} onChange={handleChange} />
                <TextField fullWidth margin="dense" name="wl_id_inapp" label="INAPP White List" type="number" value={formData.wl_id_inapp} onChange={handleChange} />
                <TextField fullWidth margin="dense" name="wl_id_ctv" label="CTV White List" type="number" value={formData.wl_id_ctv} onChange={handleChange} />

                <FormGroup
                    sx={{
                        mt: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '20px'
                    }}
                >
                    <FormControlLabel
                        control={
                            <IOSSwitch
                                checked={enableWhiteListRemoval}
                                onChange={(e) => setEnableWhiteListRemoval(e.target.checked)}
                            />
                        }
                        label={
                            <Typography
                                sx={{
                                    fontSize: '0.95rem',
                                    color: 'text.primary',
                                    marginLeft: '10px',
                                    fontWeight: 500
                                }}
                            >
                                Enable removing from the white list
                            </Typography>
                        }
                    />
                </FormGroup>

                {enableWhiteListRemoval && (
                    <>
                        <FormControl fullWidth margin="dense">
                            <InputLabel id="remove-all-label">Remove All</InputLabel>
                            <Select
                                labelId="remove-all-label"
                                name="remove_all"
                                label="Remove All"
                                value={formData.remove_all.toString()}
                                onChange={handleChange}
                            >
                                <MenuItem value="false">No</MenuItem>
                                <MenuItem value="true">Yes</MenuItem>
                            </Select>
                        </FormControl>

                        {formData.remove_all === false && (
                            <TextField
                                fullWidth
                                margin="dense"
                                name="threshold"
                                label="Threshold"
                                type="number"
                                value={formData.threshold}
                                onChange={handleChange}
                            />
                        )}
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSubmit}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}

export default CreateAdtCompanyDialog;
